import { Page } from "../../layouts/page";
import { WelcomeContainer } from "./container";

export const WelcomePage = () => {
  return (
    <Page>
      <WelcomeContainer />
    </Page>
  );
};
